var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.28,
    height: 19.28,
    viewBox: "0 0 19.28 19.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3207",
    "data-name": "Group 3207",
    transform: "translate(-460.001 -589.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Globe",
    transform: "translate(121.715 -601.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1077",
    d: "M338.286,1191.087h19.28v19.28h-19.28Z",
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-1078",
    d: "M345.428,1205.185a15.167,15.167,0,0,1-.511-4,14.971,14.971,0,0,1,.564-4.185,8.7,8.7,0,0,1-2.195-.932l.366-.666a8.043,8.043,0,0,0,2.071.869c.72-1.93,1.866-3.183,3.2-3.183s2.5,1.268,3.215,3.218a8.228,8.228,0,0,0,2.173-.888l.363.669a8.875,8.875,0,0,1-2.3.951,15.053,15.053,0,0,1,.556,4.148,15.284,15.284,0,0,1-.477,3.872,8.946,8.946,0,0,1,2.4.976l-.363.669a8.3,8.3,0,0,0-2.254-.908c-.71,2.1-1.906,3.489-3.311,3.489-1.378,0-2.555-1.331-3.268-3.364a7.858,7.858,0,0,0-1.832.8l-.366-.666A8.535,8.535,0,0,1,345.428,1205.185Zm.711-.191a13.367,13.367,0,0,1,3.032-.339,13.617,13.617,0,0,1,2.57.24,14.439,14.439,0,0,0,.463-3.71,14.208,14.208,0,0,0-.54-3.981,13.814,13.814,0,0,1-5.471-.029,14.162,14.162,0,0,0-.548,4.01A14.308,14.308,0,0,0,346.139,1204.994Zm.231.735c.612,1.7,1.549,2.782,2.555,2.782,1.024,0,1.977-1.123,2.589-2.876a12.964,12.964,0,0,0-2.343-.209,12.762,12.762,0,0,0-2.8.3Zm.077-9.287a12.782,12.782,0,0,0,2.553.251,12.927,12.927,0,0,0,2.419-.224c-.617-1.6-1.524-2.61-2.495-2.61S347.057,1194.861,346.448,1196.442Z",
    transform: "translate(-1.144 -0.458)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-1079",
    d: "M348.383,1209.282a8.1,8.1,0,1,1,8.1-8.1A8.1,8.1,0,0,1,348.383,1209.282Zm0-.771a7.326,7.326,0,1,0-7.326-7.326A7.327,7.327,0,0,0,348.383,1208.511Z",
    transform: "translate(-0.458 -0.458)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-1080",
    d: "M348,1200.8v-7.712h.771v7.712h7.712v.771h-7.712v7.712H348v-7.712h-7.712v-.771Z",
    transform: "translate(-0.458 -0.458)",
    fill: "#0c4767"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgW);
export default __webpack_public_path__ + "static/media/w.132b77220337bc58f80fcf097aeb9895.svg";
export { ForwardRef as ReactComponent };